// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.

export interface IGroup {
    id: number;
    name: string;
    parent_id: number;
    partner_id: number | null;
    org_type: OrgType;
    contact_email: string;
    priority_lock_engaged: boolean;
    enable_endpoint_map: number;
    default_pba_extended_features: boolean;
    default_pba_log_erase: boolean;
}

export enum OrgType {
    RESELLER = 1,
    MSP = 2,
    CUSTOMER = 3
}

export interface IOrgType {
  name: string;
  value: OrgType;
  manage_child?: number;
  create_child?: number;
  organizations_page?: number;
}

export const OrganizationTypes: IOrgType[] = [
    {name: 'orgtype.reseller', value: OrgType.RESELLER},
    {name: 'orgtype.msp', value: OrgType.MSP},
    {name: 'orgtype.customer', value: OrgType.CUSTOMER}
];

export const ALL_ORGS_ID = 'All';

export enum Require2FAType {
    Optional = 0,
    AdminOrReseller = 1,
    All = 2
}
